import React from "react";
import { PROGRAM_SPECIFIC_NAMES } from "../Helpers/constants";
import DxpPageShell from "./Common/StandaloneFormViews/DxpPageShell";
import DxpRegistrationTopHeader from "./DxpRegistrationTopHeader";
import {
  DxpBodyText,
  DxpHeading,
  DxpMessageCard,
  DxpNarrowColumn,
} from "./dxpStandaloneUi";

const PROGRAM = "DXP";

function SameDomainInactiveMessage({ appType }: { appType?: string }) {
  const pp = PROGRAM_SPECIFIC_NAMES.DXP.partnerProgram;

  if (appType) {
    return (
      <>
        <DxpRegistrationTopHeader program={PROGRAM} />

        <DxpPageShell appType={appType} requireCommonHeaders>
          <div className="dxp-inactive-compact-outer">
            <div className="dxp-inactive-compact-inner">
              <div className="dxp-inactive-compact-lead dxp-body-text-html">
                Your contact information has not been activated in the
                Technology Partner Program.
              </div>
              <div className="dxp-inactive-compact-panel">
                <div
                  className="dxp-body-text"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html:
                      "Reactivate your information by clicking here. Once you have reactivated please finalize the activation by <a href='https://partners.adobe.com/exchangeprogram/experiencecloud/prereg.html' target='_blank' rel='noopener noreferrer' class='dxp-text-accent-link'>clicking</a> the validation link sent by email.",
                  }}
                />
                <hr className="dxp-hr-muted-rule" aria-hidden />
                <div className="dxp-mt-16">
                  <a
                    href="https://partners.adobe.com/exchangeprogram/experiencecloud/home.html"
                    className="dxp-link-14-accent"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Go to Technology Partner Program home page
                  </a>
                </div>
              </div>
            </div>
          </div>
        </DxpPageShell>
      </>
    );
  }

  return (
    <>
      <DxpRegistrationTopHeader program={PROGRAM} />

      <DxpPageShell requireCommonHeaders>
        <div className="dxp-static-message-outer">
          <DxpNarrowColumn>
            <DxpMessageCard>
              <DxpHeading className="dxp-heading--fs-20-muted">
                Your contact information has not been activated in the{" "}
                <span>{pp.title}</span>.
              </DxpHeading>
              <DxpBodyText>
                Reactivate your information by clicking here. Once you have
                reactivated please finalize the activation by{" "}
                <a
                  href={pp.portalLink}
                  className="dxp-text-accent-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  clicking
                </a>{" "}
                the validation link sent by email.
              </DxpBodyText>
              <hr className="dxp-hr-muted-rule" aria-hidden />
              <div className="dxp-mt-16">
                <a
                  href={pp.portalLink}
                  className="dxp-float-start-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Go to {pp.portal} home page
                </a>
              </div>
            </DxpMessageCard>
          </DxpNarrowColumn>
        </div>
      </DxpPageShell>
    </>
  );
}

export default SameDomainInactiveMessage;
